import { ButtonLink, Grid } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useCardListQuery } from '../../../api/cards';
import { CardList } from '../HomePage/CardList';
import { useHasRole } from '../../../api/access';

export function CardsPage() {
  const { t } = useTranslation();
  const isAdmin = useHasRole('ADMIN');
  const cardsQuery = useCardListQuery();

  return (
    <MainLayout
      title={t('Cards')}
      actions={
        isAdmin ? <ButtonLink to="/account/cards/create">{t('Open card')}</ButtonLink> : null
      }
    >
      <Grid size={12}>
        <CardList
          cards={cardsQuery.data}
          error={cardsQuery.error}
          isLoading={cardsQuery.isPending}
          isSearchEnabled
        />
      </Grid>
    </MainLayout>
  );
}
